import React, { useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import { useForm, Controller } from 'react-hook-form';
import { COUNTRIES } from '../../constants';

export default ({ classes, onSubmit, submitErrors }) => {
  const { register, handleSubmit, setError, control, watch, errors } = useForm();

  useEffect(() => {
    submitErrors.map((error) => {
      return setError(error.param, {
        type: 'manual',
        message: error.msg,
      });
    });
  }, [submitErrors, setError]);

  const phoneInputClass = errors.phone && errors.phone.message ? 'MuiInputBase-root MuiOutlinedInput-root Mui-error Mui-error MuiInputBase-fullWidth MuiInputBase-formControl' : '';

  return (
    <Container component="main" maxWidth="xs">
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              inputRef={register({
                required: 'required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'invalid email address',
                },
              })}
              variant="outlined"
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              error={errors.hasOwnProperty('email')}
              helperText={errors.email && errors.email.message}
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              inputRef={register({
                required: 'required',
                minLength: { value: 6, message: 'Password must be at least 6 characters long' },
                validate: (value) => {
                  return value === watch('confirm_password') || "Passwords don't match";
                },
              })}
              variant="outlined"
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              error={errors.hasOwnProperty('password')}
              helperText={errors.password && errors.password.message}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              inputRef={register({ required: 'required', minLength: 6 })}
              variant="outlined"
              fullWidth
              name="confirm_password"
              label="Confirm Password"
              type="password"
              id="confirm_password"
              error={errors.hasOwnProperty('confirm_password')}
              helperText={errors.confirm_password && errors.confirm_password.message}
            />
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              inputRef={register({ required: 'required' })}
              name="first_name"
              variant="outlined"
              fullWidth
              id="first_name"
              label="First Name"
              error={errors.hasOwnProperty('first_name')}
              helperText={errors.first_name && errors.first_name.message}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              inputRef={register({ required: 'required' })}
              variant="outlined"
              fullWidth
              id="last_name"
              label="Last Name"
              name="last_name"
              error={errors.hasOwnProperty('last_name')}
              helperText={errors.last_name && errors.last_name.message}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              inputRef={register({
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'invalid email address',
                },
              })}
              variant="outlined"
              fullWidth
              id="secondary_email"
              label="Secondary Email Address"
              name="secondary_email"
              error={errors.hasOwnProperty('secondary_email')}
              helperText={errors.secondary_email && errors.secondary_email.message}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth error={!!errors.phone}>
              <Controller
                as={
                  <PhoneInput
                    containerClass={phoneInputClass}
                    country={'us'}
                    enableSearch={true}
                    inputProps={{ style: { width: '100%' } }}
                  />
                }
                name="phone"
                rules={{ required: 'required' }}
                control={control}
                defaultValue=""
              />
              <FormHelperText>{errors.phone && errors.phone.message}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              inputRef={register({ required: 'required' })}
              variant="outlined"
              fullWidth
              id="brand"
              label="Brand Name"
              name="brand"
              error={errors.hasOwnProperty('brand')}
              helperText={errors.brand && errors.brand.message}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="company"
              label="Company Name"
              name="company"
              error={errors.hasOwnProperty('company')}
              helperText={errors.company && errors.company.message}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              inputRef={register({ required: 'required' })}
              variant="outlined"
              fullWidth
              id="address"
              label="Address"
              name="address"
              error={errors.hasOwnProperty('address')}
              helperText={errors.address && errors.address.message}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl variant="outlined" fullWidth error={!!errors.country}>
              <InputLabel id="country">Country</InputLabel>
              <Controller
                as={
                  <Select>
                    {COUNTRIES.map((country) => (
                      <MenuItem key={country.id} value={country.id}>
                        {country.name}
                      </MenuItem>
                    ))}
                  </Select>
                }
                name="country"
                rules={{ required: 'required' }}
                control={control}
                defaultValue=""
              />
              <FormHelperText>{errors.country && errors.country.message}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl>
              <FormControlLabel
                control={<Checkbox id="notifications" color="primary" defaultChecked />}
                name="notifications"
                label={
                  <FormLabel htmlFor="notifications" className={classes.label}>
                    I would like to receive notifications about activities related to my profile and
                    photos, key updates and news from viBBes
                  </FormLabel>
                }
                inputRef={register()}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          Next
        </Button>
        <Grid container justify="flex-end">
          <Grid item>
            <Link href="/#/login" variant="body2">
              Already have an account? Sign in
            </Link>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};
